import classNames from "classnames";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type TimelineItemContentRootNode = HTMLDivElement;

interface TimelineItemContentProps extends React.HTMLAttributes<TimelineItemContentRootNode> {}

const TimelineItemContent = forwardRef<TimelineItemContentRootNode, TimelineItemContentProps>(
  ({ className, ...props }, ref) => {
    return <div className={twMerge(classNames("relative ml-3 flex items-center", className))} ref={ref} {...props} />;
  }
);

TimelineItemContent.displayName = TimelineItemContent.name;

export default TimelineItemContent;
